// extracted by mini-css-extract-plugin
export default {"agreementText":"AgreementText_agreementText-nTw"};